<template>
    <div id="app">
        <template v-if="$route.meta.isTab">
            <template v-if="$route.name=='cat'&&$route.query.keyword"><!--分类有搜索条件的不缓存-->
                <router-view></router-view>
            </template>
            <template v-else><!--其他情况都有缓存-->
                <keep-alive>
                    <router-view></router-view>
                </keep-alive>
            </template>
            <tabbar :index="$route.meta.tabIndex"></tabbar>
        </template>
        <keep-alive v-else-if="$route.meta.keepAlive">
            <router-view></router-view>
        </keep-alive>
        <router-view v-else></router-view>
    </div>
</template>

<script>
    import tabbar from './components/tabbar.vue'
    export default {
        name: 'app',
        data() {
            return {
            }
        },
        components: {//引用组件
            tabbar,
        },
        methods: {
        }
    }
</script>

<style>
    @import "./assets/font-awesome/css/font-awesome.css";
    @import "./assets/css/nutui.css";
    html{
        overflow-y: visible;
    }
    html{
        overflow-x:hidden;
    }
    body{
        background: rgb(243,243,243);
        margin: 0;
        padding: 0;
        color: #333233;
        position: relative;
    }
    .clear{
        clear: both;
    }
    .no-wrap {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
    .nut-searchbar .search-input input{
        padding:3px 0!important;
    }
    .two-line{
        display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;
        overflow: hidden;
    }
    .essay{
        padding: 0 0 5px 0;
    }
    .essay img{
        width: 100%!important;height: auto!important;min-height: 250px;
    }
    img{
        position: relative;
        display: block;

    }
    img:after{
        content:'';
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        min-height: 50px;
        background-image: url(assets/image/no-pic.png);
        background-size:100% 100%;
        background-repeat: no-repeat;
        background-color: #fff;
    }
</style>
